import { render, staticRenderFns } from "./ResourceCardList.vue?vue&type=template&id=729042ed&scoped=true&"
import script from "./ResourceCardList.vue?vue&type=script&lang=js&"
export * from "./ResourceCardList.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCardList.vue?vue&type=style&index=0&id=729042ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729042ed",
  null
  
)

export default component.exports